var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"qrCode"}},[_c('div',{attrs:{"id":"code"}}),_c('canvas',{attrs:{"width":"150px","id":_vm.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }